import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { selectStyles, selectTheme } from '../theme/selectTheme';

const API_URL = '/api/survey';
const toOptions = (arr) => (arr || []).map((v) => ({ value: v, label: v }));

const EMPTY_TEMP = { districts: [], blocks: [], gramPanchayats: [], villages: [], enumerators: [], startDate: '', endDate: '' };

// Filter bar for every Normal (live KoboToolbox) screen — District / Block /
// Gram Panchayat / Village / Enumerator (multi-select) + Start/End Date.
// Counterpart to shared/SundargarhFilterBar.js, whose form only has ULB/Ward.
export default function NormalFilterBar({ onApply, onClear, loading }) {
  const [options, setOptions] = useState({ districts: [], blocks: [], gramPanchayats: [], villages: [], enumerators: [] });
  const [temp, setTemp] = useState(EMPTY_TEMP);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await axios.get(`${API_URL}/normal/filters`);
        if (active && res.data?.success) {
          setOptions({
            districts: toOptions(res.data.districts),
            blocks: toOptions(res.data.blocks),
            gramPanchayats: toOptions(res.data.gramPanchayats),
            villages: toOptions(res.data.villages),
            enumerators: toOptions(res.data.enumerators),
          });
        }
      } catch (err) {
        console.error('Error fetching Normal filter options:', err);
      }
    })();
    return () => { active = false; };
  }, []);

  const handleSelect = (name) => (opts) => setTemp((p) => ({ ...p, [name]: opts || [] }));
  const handleDate = (e) => setTemp((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleApply = () => onApply({
    districts: temp.districts.map((o) => o.value),
    blocks: temp.blocks.map((o) => o.value),
    gramPanchayats: temp.gramPanchayats.map((o) => o.value),
    villages: temp.villages.map((o) => o.value),
    enumerators: temp.enumerators.map((o) => o.value),
    startDate: temp.startDate,
    endDate: temp.endDate,
  });

  const handleClear = () => {
    setTemp(EMPTY_TEMP);
    onClear();
  };

  const selectField = (label, name, placeholder) => (
    <div className="filter-group">
      <label>{label}</label>
      <Select
        isMulti
        options={options[name]}
        value={temp[name]}
        onChange={handleSelect(name)}
        placeholder={placeholder}
        styles={selectStyles}
        theme={selectTheme}
        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
        isClearable
      />
    </div>
  );

  return (
    <div className="filterbar">
      <div className="filterbar-head">
        <FilterListIcon fontSize="small" /> Filter by District, Block, Gram Panchayat, Village &amp; Enumerator
      </div>
      <div className="filter-grid">
        {selectField('District', 'districts', 'All districts')}
        {selectField('Block', 'blocks', 'All blocks')}
        {selectField('Gram Panchayat', 'gramPanchayats', 'All gram panchayats')}
        {selectField('Village', 'villages', 'All villages')}
        {selectField('Enumerator', 'enumerators', 'All enumerators')}
        <div className="filter-group">
          <label>Start Date</label>
          <input type="date" name="startDate" value={temp.startDate} onChange={handleDate} />
        </div>
        <div className="filter-group">
          <label>End Date</label>
          <input type="date" name="endDate" value={temp.endDate} onChange={handleDate} />
        </div>
      </div>
      <div className="filter-actions">
        <button className="btn btn-primary" onClick={handleApply} disabled={loading}>
          <SearchIcon fontSize="small" /> {loading ? 'Applying…' : 'Apply Filters'}
        </button>
        <button className="btn btn-secondary" onClick={handleClear} disabled={loading}>
          <ClearIcon fontSize="small" /> Clear
        </button>
      </div>
    </div>
  );
}
